import { type ReactNode } from 'react';
import { WideView } from '@components/wideView/WideView';
import { IPAD1024 } from '@shared/styles/breakpoints';
import { Layout } from 'webReservations/layout/Layout';
import { ReservationAttributesGrid } from 'webReservations/reservations/ReservationAttributesGrid';
import { ReservationStatus } from 'webReservations/reservations/ReservationStatus';
import { RestaurantHero } from '../components/RestaurantHero';
import styles from './DetailsPageView.scss';
import { ReservationStatusLabel } from '../reservations/statusHelpers';

interface DetailsViewProps {
  children: ReactNode;
  floorPlanComponent: ReactNode;
  status?: ReservationStatusLabel;
  restaurant: {
    address: string;
    id: string;
    name: string;
  };
  date: string;
  guestCount: number;
  listingPublicName: null | string;
  time: string;
  hideAddress?: boolean;
  directionsText?: string | null;
}

export const DetailsPageView = ({
  children,
  floorPlanComponent,
  status,
  restaurant,
  date,
  guestCount,
  listingPublicName,
  time,
  hideAddress,
  directionsText,
}: DetailsViewProps) => (
  <Layout>
    <main className={styles.main}>
      <RestaurantHero
        restaurant={restaurant}
        hideAddress={hideAddress}
        directionsText={directionsText}
      >
        {status && <ReservationStatus status={status} />}
      </RestaurantHero>
      <div className={styles.content}>
        <div className={styles.leftPanel}>
          <WideView
            narrowElement={
              <ReservationAttributesGrid
                containerClassName={styles.reservationAttributesContainer}
                date={date}
                guestCount={guestCount}
                publicName={listingPublicName}
                time={time}
              />
            }
            wideElement={
              <ReservationAttributesGrid
                containerClassName={styles.reservationAttributesContainer}
                date={date}
                guestCount={guestCount}
                publicName={listingPublicName}
                time={time}
                variant="inline"
              />
            }
            breakpoint={IPAD1024}
          />
          <hr />
          <div className={styles.floorPlanContainer}>{floorPlanComponent}</div>
        </div>
        <div className={styles.rightPanel}>{children}</div>
      </div>
    </main>
  </Layout>
);
